// extracted by mini-css-extract-plugin
export default {"svg":"Template_svg__LFY+k"};